// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useMapboxService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getCourseExtent = async (courseSchemaId: number) => {
        const res = await axios.get(
            `${apiUrl}/course/${courseSchemaId}/extent`,
            undefined, 
            {bypassAuthCheck:true}
        );
        return res.data;
    };

    const getAvailableTiles = async () => {
        const res = await axios.get(
            `${useStore().state.MaptilerUrl}/index.json`,
        );

        return res.data;
    };

    const getAllMosaicbyId = async (id: any) => {
        const res = await axios.get(`${apiUrl}/mapbox/mosaic/course/${id}`);

        return res.data;
    };

    const getDefaultStyle = async (
        courseSchemaId: number,
        mapStyle: string,
    ) => {
        const res = await axios.get(
            `${apiUrl}/mapbox/style/course/${courseSchemaId}/${mapStyle}.json`,
        );

        return res.data;
    };

    const getMapboxLayerTree = async (courseSchemaId) => {
        const res = await axios.get(
            `${apiUrl}/mapbox/layer/tree/${courseSchemaId}`,
        );

        return res.data;
    };

    const getAllCourseCoords = async () => {
        const res = await axios.get(`${apiUrl}/mapbox/course/coordinates`);

        return res.data;
    };

    return {
        getDefaultStyle,
        getAvailableTiles,
        getCourseExtent,
        getMapboxLayerTree,
        getAllMosaicbyId,
        getAllCourseCoords,
    };
};
